import React from 'react';
import './Programs.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Programs = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="programs" id="programs">
      <div className="programs-title">
        <div className="programs-tag">
          <span className="programs-tag-text">{t.programsTag}</span>
        </div>
        <h2 className="programs-heading">{t.programsTitle}</h2>
        <p className="programs-subtitle">{t.programsSubtitle}</p>
      </div>
      
      <div className="programs-cards">
        <div className="programs-card">
          <div className="programs-card-container">
            <div className="programs-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="programs-card-text">
              <h3 className="programs-card-title">{t.programsStudents}</h3>
              <p className="programs-card-description">
                {t.programsStudentsText}
              </p>
            </div>
          </div>
          <a href="#contact-form" className="programs-card-button">{t.programsStudentsButton}</a>
        </div>

        <div className="programs-card">
          <div className="programs-card-container">
            <div className="programs-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="programs-card-text">
              <h3 className="programs-card-title">{t.programsTeachers}</h3>
              <p className="programs-card-description">
                {t.programsTeachersText}
              </p>
            </div>
          </div>
          <a href="#contact-form" className="programs-card-button">{t.programsTeachersButton}</a>
        </div>

        <div className="programs-card">
          <div className="programs-card-container">
            <div className="programs-card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 16V8C21 7.46957 20.7893 6.96086 20.4142 6.58579C20.0391 6.21071 19.5304 6 19 6H5C4.46957 6 3.96086 6.21071 3.58579 6.58579C3.21071 6.96086 3 7.46957 3 8V16C3 16.5304 3.21071 17.0391 3.58579 17.4142C3.96086 17.7893 4.46957 18 5 18H19C19.5304 18 20.0391 17.7893 20.4142 17.4142C20.7893 17.0391 21 16.5304 21 16Z" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3 10H21" stroke="#49A598" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="programs-card-text">
              <h3 className="programs-card-title">{t.programsManagers}</h3>
              <p className="programs-card-description">
                {t.programsManagersText}
              </p>
            </div>
          </div>
          <a href="#contact-form" className="programs-card-button">{t.programsManagersButton}</a>
        </div>
      </div>
    </section>
  );
};

export default Programs;
